import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

type CriticalExposuresBreadcrumbsProps = {
  scope: SpaceOrWorkspaceScope;
};

export function CriticalExposuresBreadcrumbs({
  scope,
}: CriticalExposuresBreadcrumbsProps) {
  const breadcrumbs = [
    <Link
      key="/space/overview"
      component={RouterLink}
      to={`/space/overview?${scope.params}`}
      display="flex"
    >
      <HomeIcon fontSize="inherit" />
    </Link>,
    <Link
      key="/space/dashboard"
      component={RouterLink}
      to={`/space/dashboard?${scope.params}`}
      underline="hover"
      color="text.primary"
    >
      Dashboard
    </Link>,
    <Typography key="critical-exposures" color="text.primary">
      Critical Exposures
    </Typography>,
  ];

  return (
    <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
      {breadcrumbs}
    </Breadcrumbs>
  );
}
